import { getAPICallServer, postAPICallServer } from '../utils/axios.util'
import { apiServerRoutes } from '../constants/apiRoutes'

class tractorService {
  async createDraft(req: any) {
    return postAPICallServer(apiServerRoutes.DRAFT_LISTING, req.body, req)
  }

  async saveListing(req: any) {
    const id = req.body.id
    const payload = {
      basic: req.body?.basic ?? {},
      features: req.body?.features ?? {},
      configs: req.body?.configs ?? {},
      is_last_step: req.body?.is_last_step ?? false,
    }

    return postAPICallServer(
      apiServerRoutes.SAVE_LISTING.replace(':id', id),
      payload,
      req,
    )
  }

  async listingDetails(req: any) {
    return getAPICallServer(
      apiServerRoutes.LISTING_DETAILS.replace(':id', req.body.id),
      req,
    )
  }

  async saveTractorConfig(req: any) {
    return postAPICallServer(
      apiServerRoutes.CONFIG_TRACTOR.replace(':id', req.body.tractorId),
      req.body.data,
      req,
    )
  }
}

export default new tractorService()
